<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>REGION<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_region_save" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="regions" [actionExclude]="['feedback','column']"  [checkboxCol]="true"
            [entityColumns]="regionColumns" [selectionField]="'Region_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addRegion($event)" (editEntity)="editRegion($event)"
            (refreshEntities)="refreshRegions($event)" (deleteEntity)="deleteRegion($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)" ></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearRegion()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Region Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'RegionName'" [(ngModel)]="entity.RegionName"  id="txt_region_Name"
                      ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                     [fieldName]="'Code'"  [(ngModel)]="entity.Code" id="txt_region_Code"
                    ngDefaultControl  ></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Region Head'"   [formData]="entity" [data]="employees" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllEmployees($event)" [class] = "'form-control'" id="drp_region_Head"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
            </div>

            <div class="row"> 
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllCompany($event)" id="drp_region_Company"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'State'" [data]="state" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"  id="drp_region_State"
                        [(ngModel)]="entity.State_Id" [textField]="'StateName'" [valueField]="'State_Id'"
                        [fieldName]="'State_Id'" (filterChanged)="getAllState($event)"   [selectedItem]="selectedState" (selectionChanged)="Statechanged($event)" ngDefaultControl>
                    </dropdown>                 
                </div>
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone'" [formData]="entity" [data]="zone" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"  id="drp_region_Zone"
                        [(ngModel)]="entity.Zone_Id" [textField]="'ZoneName'" [valueField]="'Zone_Id'"
                        [fieldName]="'Zone_Id'"  [selectedItem]="selectedZone" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="false" id="txt_region_Email"
                        [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl  ></textbox> 
                </div> 
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'" id="txt_region_Phone"
                        [(ngModel)]="entity.Phone" (paste)="onPaste($event)" (keypress)="numberOnly($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div> 
            </div>
            <div class="row"> 
                
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive" ></checkbox>
                </div>
            </div> 
            <div class="row">
                <!-- <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'" id="btn_region_save"></btn>
                </div> -->
            </div>
        </div>
       
    </div>
</div>

<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Region Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="RegionName" class="label label-1">Region Name : </label> {{details.RegionName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Region Head : </label> {{details.EmployeeName}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="StateName" class="label label-1">State : </label>  {{details.StateName}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
          </div>
        </div>
    </div>

    </kendo-dialog>



<kendo-excelexport [data]="regions.data" [collapsible]="true" fileName="Region.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="RegionName" title="Region" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="RegionCode" title="Code" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="EmployeeName" title="Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ZoneName" title="Zone" [width]="200">
    </kendo-excelexport-column>   -->    
    <kendo-excelexport-column field="RegionMail" title="Email" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="RegionPhone" title="Phone" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="StateName" title="State" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>